import { useQuery, UseQueryOptions } from 'react-query';

import { State } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useStatesQuery(
	search: string | null = null,
	options?: Omit<UseQueryOptions<State[], unknown, State[], string[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.States(search),
		() => AxiosUtils.getResponseData<State[]>(api.get(CerebroApiEndpoints.Lookups.States(search))),
		options
	);
}
